<!-- Seasonal Popup (shows on home page load; respects user's daily skip preference) -->
<app-seasonal-popup></app-seasonal-popup>

<!-- Main Content -->
<div class="container dashboard-container py-4">
  <div class="row dashboard-row">
    <!-- Main Content Column -->
    <div class="col-lg-8 main-content">
      <!-- Banner Section -->
      <div class="banner-section mb-4">
        <div class="banner-wrapper">
          <img class="img-fluid banner-image" 
               src="./assets/img/college/banner.jpg" 
               alt="College of Pharmacy Banner">
          <div class="banner-overlay">
            <div class="banner-text">
              <h1 class="banner-title">College of Pharmacy (Poly), Akluj</h1>
              <p class="banner-subtitle">Excellence in Pharmaceutical Education</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Vision & Mission Section -->
      <div class="vision-mission-section">
        <!-- Vision Card -->
        <div class="card vision-card shadow-sm mb-4">
          <div class="card-header">
            <div class="header-icon vision-icon">
              <i class="fas fa-eye"></i>
            </div>
            <h5 class="header-title">Our Vision</h5>
          </div>
          <div class="card-body">
            <p class="card-text">
              To become one of the leading institutes of higher education with a focus on developing global competencies 
              through advanced technologies, disciplined learning, and innovative resources, contributing significantly 
              to national development in pharmaceutical sciences.
            </p>
          </div>
        </div>

        <!-- Mission Card -->
        <div class="card mission-card shadow-sm mb-4">
          <div class="card-header">
            <div class="header-icon mission-icon">
              <i class="fas fa-bullseye"></i>
            </div>
            <h5 class="header-title">Our Mission</h5>
          </div>
          <div class="card-body">
            <p class="card-text">
              To provide high-quality pharmaceutical education and practical training to students from diverse backgrounds, 
              particularly focusing on rural areas of Maharashtra, enabling them to meet the healthcare needs of the community 
              with excellence and dedication.
            </p>
          </div>
        </div>
      </div>
      <!-- Admission Notification -->
      <div class="card admission-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon admission-icon">
            <i class="fas fa-bell"></i>
          </div>
          <h5 class="header-title">Admission Notification</h5>
        </div>
        <div class="card-body">
          <div class="notification-list">
            <div class="notification-item" *ngFor="let adv of advertiseList; let i = index">
              <div class="notification-icon">
                <i class="fas fa-file-alt"></i>
              </div>
              <a target="_blank" href="{{adv.filename}}" class="notification-link">
                {{adv.displayText}}
              </a>
              <div class="notification-badge">New</div>
            </div>
          </div>
        </div>
      </div>

      <!-- News and Events -->
      <div class="card news-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon news-icon">
            <i class="fas fa-newspaper"></i>
          </div>
          <h5 class="header-title">News and Events</h5>
        </div>
        <div class="card-body">
          <div class="news-list">
            <div class="news-item" *ngFor="let newsNEvent of newsNEvents; let i = index">
              <div class="news-icon">
                <i class="fas fa-calendar-alt"></i>
              </div>
              <a href="{{newsNEvent.filename? newsNEvent.filename : newsNEvent.link}}"
                 target="_blank" 
                 class="news-link">
                {{newsNEvent.displayText}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar Widgets Column -->
    <div class="col-lg-4 sidebar-column">
      <!-- Motto Widget -->
      <div class="card motto-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon motto-icon">
            <i class="fas fa-quote-left"></i>
          </div>
          <h5 class="header-title">Our Motto</h5>
        </div>
        <div class="card-body text-center motto-body">
          <div class="logo-wrapper">
            <img alt="College Logo" 
                 src="./assets/img/college/logo.png" 
                 class="motto-logo">
          </div>
          <div class="motto-text-wrapper">
            <p class="motto-quote">"Tewo Sada Dnyanamaya pradeep"</p>
            <p class="motto-translation">Let the light of knowledge shine forever</p>
          </div>
        </div>
      </div>

      <!-- Important Links Card -->
      <div class="card links-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon links-icon">
            <i class="fas fa-link"></i>
          </div>
          <h5 class="header-title">Important Links</h5>
        </div>
        <div class="card-body p-0">
          <div class="links-list">
            <a *ngFor="let link of importantLinks" 
               [href]="link.filename || link.link"
               target="_blank"
               class="link-item">
              <i class="fas fa-external-link-alt link-icon"></i>
              <span class="link-text">{{link.displayText}}</span>
              <i class="fas fa-chevron-right link-arrow"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Academic Resources Card -->
      <div class="card academic-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon academic-icon">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <h5 class="header-title">Academic Resources</h5>
        </div>
        <div class="card-body p-0">
          <div class="links-list">
            <a *ngFor="let link of academicLinks" 
               [href]="link.filename || link.link"
               target="_blank"
               class="link-item">
              <i class="fas fa-book link-icon"></i>
              <span class="link-text">{{link.displayText}}</span>
              <i class="fas fa-chevron-right link-arrow"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Newsletter Card -->
      <div class="card newsletter-card shadow-sm mb-4">
        <div class="card-header">
          <div class="header-icon newsletter-icon">
            <i class="fas fa-newspaper"></i>
          </div>
          <h5 class="header-title">Newsletter</h5>
        </div>
        <div class="card-body p-0">
          <div class="links-list">
            <a *ngFor="let link of newsletter" 
               [href]="link.filename || link.link"
               target="_blank"
               class="link-item">
              <i class="fas fa-file-pdf link-icon"></i>
              <span class="link-text">{{link.displayText}}</span>
              <i class="fas fa-chevron-right link-arrow"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>